import { questionApi } from '@/lib/api/questionnaireApi';
import { useQuery } from '@tanstack/react-query';

export default function useQuestion({ questionId }: { questionId: number }) {
  const {
    data: questionDetails,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['question', questionId],
    queryFn: () => questionApi.getById(questionId!),
    enabled: questionId !== null,
  });

  return {
    questionDetails,
    isLoading,
    error,
  };
}
